import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { DrawerFilterConfirmationPayment } from "./Components/DrawerFilter/DrawerFilterConfirmationPayment";
import { ReportConfirmationPaymentPDF } from "./Components/PDF/ReportConfirmationPaymentPDF";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { NoEmptyPdfCore } from "src/Pages/components/PDF/NoEmpty/NoEmptyPdfCore";

export const PageReportConfirmationPayment = () => {
  const { loadingGravar } = useConfigPageContext();
  const { listReportConfirmationPayment } = useContextReportsProduction();

  const totalRows =
    (listReportConfirmationPayment?.data?.corretor?.length ?? 0) +
    (listReportConfirmationPayment?.data?.supervisor?.length ?? 0) +
    (listReportConfirmationPayment?.data?.gerente?.length ?? 0);
  const hasData = totalRows > 0;

  return (
    <>
      <CardHeaderCore
        buttonAdd={[
          <DrawerFilterConfirmationPayment
            key="filter"
            isUserProducer={false}
          />,
        ]}
        icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}
        sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}
        subTitle="Gere relatórios detalhados de pagamentos com filtros personalizados"
        title="Relatório de Pagamentos"
      />

      <ReportConfirmationPaymentPDF />

      {!hasData && !loadingGravar && <NoEmptyPdfCore />}
    </>
  );
};
